"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubDashboardProgressView = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var StageBarChart_1 = require("../StageBarChart/StageBarChart");
var PackagingStatus_1 = require("../PackagingStatus/PackagingStatus");
require("./styles/progress-view.scss");
/**
 * Progress-focused dashboard view with stage chart and table.
 *
 * @param {WsAiHubDashboardProgressViewProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubDashboardProgressView = function (props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "ws-ai-hub-page-bar" },
            react_1.default.createElement(StageBarChart_1.WsAiHubStageBarChart, { legendVisible: true, stage1: props.stageCounts.stage1, stage2: props.stageCounts.stage2, stage3: props.stageCounts.stage3, stage4: props.stageCounts.stage4, stage5: props.stageCounts.stage5, stage6: props.stageCounts.stage6, stage7: props.stageCounts.stage7 })),
        react_1.default.createElement("div", { className: "ws-ai-hub-stage-table-wrap" },
            react_1.default.createElement("table", { className: "table is-hoverable is-fullwidth ws-ai-hub-stage-table" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "AI Use Case"),
                        react_1.default.createElement("th", null, "Backlog"),
                        react_1.default.createElement("th", null, "Qualification"),
                        react_1.default.createElement("th", null, "Prioritisation"),
                        react_1.default.createElement("th", null, "Definition"),
                        react_1.default.createElement("th", null, "Readiness"),
                        react_1.default.createElement("th", null, "Implementation"))),
                react_1.default.createElement("tbody", null, props.useCases.map(function (useCase) {
                    return (react_1.default.createElement("tr", { key: "ws-application-" + useCase.id },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: "/deliver/ai/use-cases/" + useCase.id }, useCase.title || 'AI Use Case')),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(PackagingStatus_1.WsPackagingStatus, { useCase: useCase, status: 1 })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(PackagingStatus_1.WsPackagingStatus, { useCase: useCase, status: 2 })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(PackagingStatus_1.WsPackagingStatus, { useCase: useCase, status: 3 })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(PackagingStatus_1.WsPackagingStatus, { useCase: useCase, status: 4 })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(PackagingStatus_1.WsPackagingStatus, { useCase: useCase, status: 5 })),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(PackagingStatus_1.WsPackagingStatus, { useCase: useCase, status: 6 }))));
                }))))));
};
exports.WsAiHubDashboardProgressView = WsAiHubDashboardProgressView;
